export default __webpack_public_path__ + "static/media/truck-maintenance.d882c3f5.jpeg";